module.exports = __webpack_public_path__ + "assets/img/2.fd770115.gif";